<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class="container-fluid">

                <div class="row">
                    <div class="col-12 mb-4">

                        <v-card>
                            <v-card-title>

                                Gestion des articles
                                <v-spacer></v-spacer>
                                <v-text-field
                                        v-model="search"
                                        append-icon="mdi-magnify"
                                        label="Rechercher ..."
                                        single-line
                                        hide-details
                                ></v-text-field>
                            </v-card-title>

                            <v-data-table
                                    :headers="headers"
                                    :items="blogs"
                                    :search="search"
                                    sort-by="name"
                                    class="elevation-1"
                                    :loading="blogloading" loading-text="Chargement en cours...">
                                <template v-slot:item.image="{item}">
                                    <a :href="item.image" target="_blank">

                                        <img class="btn" :src="item.image" style="width: 120px;cursor: pointer;"  v-on="on" />
                                    </a>
                                </template>
                                <template v-slot:item.contente="{item}">
                                   <p v-html="item.contente.substr(0,50)+'...'"></p>
                                </template>
                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-spacer></v-spacer>
                                        <v-dialog v-model="dialog"  style="z-index: 9999" max-width="1000px">
                                            <template v-slot:activator="{ on }">
                                                <v-btn style="background: #2A3042;color: #fff" class="mb-2" v-on="on">Nouvel article
                                                </v-btn>
                                            </template>
                                            <v-card>
                                                <v-card-title>
                                                    <span class="headline">{{ formTitle }}</span>
                                                </v-card-title>

                                                <v-card-text>


                                                    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                        <v-alert v-if="errors" dense outlined
                                                                 :type="(errors.update_error)?'error':'success'">
                                                            {{errors.operation}}
                                                        </v-alert>

                                                        <v-text-field v-if="submitting" color="primary" loading
                                                                      disabled></v-text-field>
                                                        <v-row>
                                                            <v-col cols="12" >
                                                                <v-file-input v-model="editedItem.image"  :rules="editedIndex === -1?fileRules:''"  filled prepend-icon="mdi-camera" show-size  accept="image/*" label="Image"></v-file-input>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="12">
                                                                <v-text-field
                                                                        clearable :rules="TitreRules" v-model="editedItem.title"
                                                                        label="Titre" placeholder="ex : Covid 19"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" sm="6" md="12">
                                                                <v-select
                                                                        :rules="TypeRules"
                                                                        v-model="editedItem.type"
                                                                        :items="items"
                                                                        label="Type"
                                                                        persistent-hint
                                                                ></v-select>
                                                            </v-col>

                                                            <v-col cols="12" sm="6" md="12">
                                                                <editor
                                                                        :rules="ContenuRules"
                                                                        v-model="editedItem.contente"
                                                                        api-key="yfms8az1wlgnme4a14cm4hrn43e2pmxe5ballw128a5uie4w"
                                                                        :init="{height: 200,menubar: false,plugins: ['advlist autolink lists link image charmap print preview anchor','searchreplace visualblocks code fullscreen','insertdatetime media table paste code help wordcount'
 ],
         toolbar:
           'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help'
       }"
                                                                />
                                                            </v-col>


                                                        </v-row>
                                                    </v-form>
                                                </v-card-text>

                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                                                    <v-btn color="blue darken-1"  :disabled="!valid" text @click="save">Sauvegarder</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-toolbar>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <v-icon small class="mr-2" @click="editItem(item)">
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon small @click="deleteItem(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                                <template v-slot:no-data>
                                    <v-btn color="default" @click="initialize">Actualiser</v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                    </div>
                </div>
                <v-snackbar
                        v-model="snackbar"
                        timeout="2000"
                >
                    {{ textSnack }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbar = false"
                        >
                            Fermer
                        </v-btn>
                    </template>
                </v-snackbar>

            </div> <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

    </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import Editor from '@tinymce/tinymce-vue'

    export default {
        name: "Blog",
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                errors:undefined,
                search: '',
                dialog: '',
                id: undefined,
                snackbar: false,
                textSnack: '',
                items: ['Article', 'Conseil santé'],
                headers: [
                    {
                        text: 'Image',
                        align: 'start',
                        sortable: true,
                        value: 'image',
                    },
                    {text: 'Titre', value: 'title'},
                    {text: 'Type', value: 'type'},
                    {text: 'Contenu', value: 'contente'},
                    {text: 'Actions', value: 'actions', sortable: false},
                ],
                editedIndex: -1,
                editedItem: {
                    password: '',
                    email: '',
                    name: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    password: '',
                    email: '',
                    name: '',
                    _id: 0,
                    created_at: 0,
                },
                TitreRules: [
                    v => !!v || 'Titre requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                TypeRules: [
                    v => !!v || 'Type requis',
                ]
                ,
                ContenuRules: [
                    v => !!v || 'Contenu requis',
                ],
                fileRules: [
                    v => !!v || 'File required',
                ],

            }
        }
        ,
        components: {
            'editor': Editor
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvel article" : "Mise à jour"
            }
            ,
            ...mapState('blogs/', ['blogs','blogloading'])

        }
        ,
        mounted() {
            this.$store.dispatch('blogs/getBlog').then(response => {
                window.console.log('blogs', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,

            editItem(item) {
                this.editedIndex = this.blogs.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            }
            ,

            deleteItem(item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir supprimé ce élement?",
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('blogs/deleteBlog', item._id).then((result) => {
                            console.log("del");
                            console.log(result);
                            this.snackbar = true;
                            this.textSnack = result.data.message;
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: result.data.message,
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {
                this.submitting = true;
                let data = new FormData();
                data.append("file", this.editedItem.image);
                data.append("titre", this.editedItem.title);
                data.append("type", this.editedItem.type);
                data.append("contenu", this.editedItem.contente);
                let mineroute = 'blogs/setBlog';
                if (this.editedIndex>-1){
                    data.append("id",this.editedItem._id);
                    mineroute = 'blogs/setBlog';
                }
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.close();
                        this.editedItem.contente = '';
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>